import { ZapFastIcon } from "@Light/components/enroll/Icons";
import { ServiceStartType } from "@Light/components/enroll/types";
import { Button } from "@Light/components/page/Button";
import { PageBody } from "@Light/components/page/PageBody";
import { useNavigate } from "@Light/utils/context";
import React from "react";

export type BaseConfirmationProps = {
  serviceStartType: ServiceStartType;
  dueDate: string;
  exitTo: string;
  bodyText: string;
};

export const BaseConfirmation: React.FC<BaseConfirmationProps> = ({
  exitTo,
  bodyText,
}) => {
  const navigate = useNavigate();

  return (
    <PageBody
      centered
      centerText
      icon={ZapFastIcon}
      title={<div className="text-balance">Your new plan is on its way!</div>}
      subtitle={bodyText}
      footer={
        <Button
          size="lg"
          className="w-full"
          onClick={() => {
            navigate(exitTo);
          }}
        >
          All set
        </Button>
      }
    />
  );
};
